import axios from 'axios';
import { ID, SingleApiResponse } from '@ianesthesie-kit/services';
import { PaymentLink } from './paymentLink.model';

/**
 * BFF client for a billing line's payment link (`/billing/line/{id}/payment-link`). The hospital
 * and the calling user travel via headers — never sent from here. Static-only, following
 * {@link DeskPaymentService}'s surface.
 */
export class PaymentLinkService {
  private static BASE_URL = '/billing/line';

  /**
   * Mints the link, or hands back the line's OPEN one when its amount still equals the balance.
   * Records nothing on the trail: this is the desk copying a link, not chasing the patient.
   */
  public static create(lineId: ID): Promise<PaymentLink> {
    return axios
      .post<SingleApiResponse<PaymentLink>>(
        `${this.BASE_URL}/${lineId}/payment-link`
      )
      .then((resp) => resp.data.data);
  }
}
